export default __webpack_public_path__ + "static/media/PsychAssoc_logo_full_alt.236a63b2.png";